<template>
<!-- snb -->
<nav id="snb">
    <!-- ************************ -->
    <!-- My Page -->
    <section class="snb_sec mypage_wrap">
        <h2>{{$t('TITLE.GLOBAL.MYPAGE')}}</h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myPage top 3 -->
                <li v-for="menu in myPageList" :key="menu.menuId">
                    <a href="javascript:" @click="handleMoveMenu(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <!-- ************************ -->
    <!-- My Menu -->
    <section class="snb_sec mymenu_wrap">
        <h2>
            {{ $t('TITLE.GLOBAL.MYMENUS') }}
            <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnMyMenuConfig">
                <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
            </a>
        </h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myMenus top 3 -->
                <li v-for="menu in myMenusList" :key="menu.menuId">
                    <a href="javascript:" @click="handleMoveMenuByMenuId(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="snb_sec myctg_wrap">
        <h2>
            {{ $t('TITLE.GLOBAL.QUICKCATEGORY') }}
            <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnCatConfig">
                <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
            </a>
        </h2>
        <div class="list">
            <ul class="list_myctg">
                <!-- myCategory top 3 -->
                <li v-for="cat in quickCategoryList" :key="cat.category3">
                    <a
                        href="javascript:"
                        @click="setCategoryParam(cat.category1, cat.category2, cat.category3)"
                    >{{ cat.categoryNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="snb_sec notice_wrap">
        <h2>{{ $t('TITLE.GLOBAL.RECENTMODEL') }}</h2>
        <div class="list">
            <ul class="list_model">
                <!-- Recent Model top 5 -->
                <li v-for="model in recentModelList">
                    <a href="javascript:" @click="setModel(model)">{{ model.modelNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="bn_wrap">
        <ul class="list_banner">
            <li class="bn_box">
                <a href="javascript:" class="ico_support" :title="$t('TITLE.LEFT.MENU.SUPPORT')" @click="btnSupport">{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</a>
            </li>
        </ul>
    </section>

</nav>
<!-- //snb -->
</template>

<script>
import Vue                          from 'vue';
import { mapGetters, mapActions }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import qs                           from 'query-string';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }        from '@/utils';
import { EventBus }                 from '@/utils/EventBus';
import MyMenuConfigPopup            from '~vb/common/MyMenuConfigPopup';
import CategoryConfigPopup          from '~vb/common/CategoryConfigPopup';

const fetchSearchAllSetting = () => axios.post(`${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeAllSetup.skp`);
const fetchSearchSetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeSetup.skp`,
    qs.stringify({ WORK_TYPE : workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'SearchAscSnb',
    data() {
        return {
            params: {},
            myPageList: [],
            myMenusList: [],
            quickCategoryList: [],
            recentModelList: []
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
            loginSystem: 'getLoginSystem',
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo();
        },
        getMyPageList() {
            return this.myPages['subMenu'] || [];
        }
    },
    watch: {
        myMenusList(list) {
            this.myMenusList = list;
        },
        quickCategoryList(list) {
            this.quickCategoryList = list;
        },
        recentModelList(list) {
            this.recentModelList = list;
        }
    },
    methods: {
        ...mapActions(['changeSubsidiary', 'setReturnSystem']),
        // 컴포넌트 생성시 동작
        async initLoad() {
            this.myPageList = this.getMyPageList;
            const resAll    = await fetchSearchAllSetting();
            return resAll.data;
        },
        // myMenus 클릭 시 이벤트
        handleMoveMenuByMenuId(menuObj) {
            let menuId = menuObj.menuId3 || menuObj.menuId2 || menuObj.menuId1;
            let sMenu = _.find(MenuUtil.menuScan(menuId, this.menus), function(m) { return m.menuId == menuId });
            this.handleMoveMenu(sMenu);
        },
        // 메뉴 이동 이벤트
        handleMoveMenu(menu) {
            store.commit(
                'PARAMS',
                Object.assign(
                    this.storeParams,
                    {
                        menuId : menu.menuId,
                        menuGrpCd : menu.menuGrpCd || '',
                        menuGrpDetailCd : menu.menuGrpDetailCd || '',
                        creationYn : menu.creationYn
                    }
                )
            );

            // URL 이 없는 경우
            if (SDLUtil.isNull(menu['connUrl'])) {
                return false;
            }

            let connUrl = menu.connUrl.replace('.skp', '');
            this.$router.push(connUrl);
        },
        // myMenus 조회
        async searchMyMenusList() {
            return await fetchSearchSetting('MENU')
                        .then(res => { this.setMyMenusList({ myMenus: res.data }); })
                        .catch(err => { 
                            console.log('Err.searchMyMenusList ===> ', err);
                            SDLUtil.errorAlert(err); 
                        });
        },
        // myMenus List 설정
        setMyMenusList(res) {
            // My Menus data setting
            let refineMyMenuslList = [], myMenusList = [];
            if(SDLUtil.isNull(res.myMenus.result)) {
                myMenusList = res.myMenus.rowData;   
            } else {
                myMenusList = res.myMenus.result.rowData;
            }

            if(myMenusList.length > 0) {
                myMenusList = _.sortBy(myMenusList, ["ROW_NUM"]);
                for(let menu of myMenusList) {
                    refineMyMenuslList.push({
                        menuNm: this.setLinkedName(menu.WORK_KEY_1_NM, menu.WORK_KEY_2_NM, menu.WORK_KEY_3_NM),
                        menuId1: menu.WORK_KEY_1 || '',
                        menuId2: menu.WORK_KEY_2 || '',
                        menuId3: menu.WORK_KEY_3 || '',
                    });
                };
                this.myMenusList = refineMyMenuslList;
            }
        },
        // SNB 태그 생성
        setLinkedName(name1, name2, name3) {
            let linkedName = [], gt = " > ";
            if(!SDLUtil.isNull(name1)) { linkedName.push(name1); }
            if(!SDLUtil.isNull(name2)) { linkedName.push(gt); linkedName.push(name2); }
            if(!SDLUtil.isNull(name3)) { linkedName.push(gt); linkedName.push(name3); }
            return linkedName.join("");
        },

        // My Menu config
        btnMyMenuConfig() {
            SDLUtil.show( MyMenuConfigPopup, { rtnFunc: () => { this.searchMyMenusList(); } }, { height: 'auto' } );
        },
        // Quick Category config
        btnCatConfig() {
            SDLUtil.show( CategoryConfigPopup, { rtnFunc: () => { this.searchQuickCategoryList(); } }, { height: 'auto' } );
        },
        // Quick Category 조회
        async searchQuickCategoryList() {
            return await fetchKnowledgeSetting('CATEGORY')
                        .then(res => { this.setQuickCategoryList({ quickCategory: res.data }); })
                        .catch(err => { SDLUtil.errorAlert(err); });
        },
        // Quick Category List 설정
        setQuickCategoryList(res) {
            // Quick Category data setting
            let refineCategoryList = [], quickCategoryList = [];
            if(SDLUtil.isNull(res.quickCategory.result)) {
                quickCategoryList = res.quickCategory.rowData;
            } else {
                quickCategoryList = res.quickCategory.result.rowData;
            }

            if(quickCategoryList.length > 0) {
                quickCategoryList = _.sortBy(quickCategoryList, ["ROW_NUM"]);
                for(let category of quickCategoryList) {
                    refineCategoryList.push({
                        categoryNm: this.setLinkedName(category.WORK_KEY_1_NM, category.WORK_KEY_2_NM, category.WORK_KEY_3_NM),
                        category1: category.WORK_KEY_1 || '',
                        category2: category.WORK_KEY_2 || '',
                        category3: category.WORK_KEY_3 || '',
                    });
                };

                this.quickCategoryList = refineCategoryList;
                // KnowledgeSearch.vue 로 카테고리 리스트 전달
                EventBus.$emit('mobile-category', this.quickCategoryList);
                
            } else {
                this.quickCategoryList = [];
                // KnowledgeSearch.vue 로 카테고리 리스트 전달
                EventBus.$emit('mobile-category', this.quickCategoryList);

            }
        },
        // 선택한 Category param을 카테고리 컴포넌트로 전달 -> CategoryComboBox.vue
        setCategoryParam(cat1, cat2, cat3) {
            let param = {
                prodCateCd1: cat1,
                prodCateCd2: cat2,
                prodCateCd3: cat3
            };
            console.log('Snb.param --> ', param);
            EventBus.$emit('quick-category', param);
        },
        // Recent Model 조회
        async searchRecentModelList() {
            return await fetchKnowledgeSetting('MODEL')
                        .then(res => { this.setRecentModelList({ recentModel: res.data }); })
                        .catch(err => { SDLUtil.errorAlert(err); });
        },
        // Recent Model List 설정
        setRecentModelList(res) {
            // Recent Model data setting
            let refineRecentModelList = [], recentModelList = [];
            if(SDLUtil.isNull(res.recentModel.result)) {
                recentModelList = res.recentModel.rowData;
            } else {
                recentModelList = res.recentModel.result.rowData;
            }

            if (recentModelList.length > 0) {
            recentModelList = _.sortBy(recentModelList, ["ROW_NUM"]);
                for(let model of recentModelList) {
                    refineRecentModelList.push({
                        model: model.WORK_KEY_1 || '',
                        modelNm: model.WORK_KEY_1 || ''
                    });
                };

                this.recentModelList = refineRecentModelList;
            }
        },
        // 선택한 Model 검색 컴포넌트로 전달 -> KnowledgeSearch.vue
        setModel(model) {
            // Call KnowledgeSearch.vue handleSelectModel method
            EventBus.$emit('select-recent-model', model.modelNm);
        },

        async btnSupport() {
            let reLoginData = { loginSystem : 'SUPPORT' };
            this.setReturnSystem(this.loginSystem);
            if(Number(this.deptLevelCd) === 1) {
                Object.assign(reLoginData, {
                    topRhqCd : this.loginRhq,
                    topSubsidiaryCd : this.userCorpCd,
                });

            } else {
                Object.assign(reLoginData, {
                    topRhqCd : $('#selectRhqCd :selected').val(),
                    topRhqNm : $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd : $('#selectRhqSubCd :selected').val(),
                    topSubsidiaryNm : $('#selectRhqSubCd :selected').html(),
                });
            };

            SDLUtil.showLoadingBar(true);
            const loginResult = await this.changeSubsidiary(reLoginData)
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });

            this.afterLoginProcess(loginResult);
        },
        // Support 변경 후 처리
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            EventBus.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        // 메인 호출 이벤트
        gotoMain() {
            window.scrollTo(0, 0);
            this.$router.push(MenuUtil.getSupportMain());
        },
    },
    // keep-alive activated
    activated() {
        this.initLoad()
            .then(res => {
                this.setMyMenusList(res);
                this.setQuickCategoryList(res);
                this.setRecentModelList(res);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });

        // SNB 이벤트 등록
        EventBus.$on('my-menus-reload',       () => { this.searchMyMenusList(); });
        EventBus.$on('quick-category-reload',   () => { this.searchQuickCategoryList(); });
        EventBus.$on('recent-model-reload',     () => { this.searchRecentModelList(); });
    },
    // keep-alive deactivated
    deactivated(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('my-menus-reload');
        EventBus.$off('quick-category-reload');
        EventBus.$off('recent-model-reload');
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchAscSnb.vue